const clean = (value) => String(value || '').trim().replace(/\s+/g, ' ');
const tokens = (value) => clean(value).toLowerCase().split(/\s+/).filter(Boolean);
const NON_DISTINCTIVE_BRAND_TOKENS = new Set([
  'based',
  'brand',
  'brands',
  'burger',
  'burgers',
  'co',
  'company',
  'corp',
  'corporation',
  'food',
  'foods',
  'hamburger',
  'hamburgers',
  'inc',
  'llc',
  'meat',
  'meats',
  'plant',
  'product',
  'products',
]);

const identityTokens = (value) => clean(value)
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .split(/\s+/)
  .filter(Boolean);

const distinctiveBrandTokens = (value) => {
  const significant = identityTokens(value).filter((word) => word.length >= 3);
  const distinctive = significant.filter((word) => !NON_DISTINCTIVE_BRAND_TOKENS.has(word));
  return distinctive.length > 0 ? distinctive : significant;
};

const labelCoversContext = (label, context) => {
  const contextTokens = tokens(context);
  if (contextTokens.length === 0) return true;
  const labelTokens = new Set(tokens(label));
  return contextTokens.every((token) => labelTokens.has(token));
};

export function buildContextualProductInput({ label, productContext, brand, productType } = {}) {
  const variantLabel = clean(label);
  const context = clean(productContext);
  const brandName = clean(brand);
  const typeName = clean(productType);
  if (!variantLabel) return context || [brandName, typeName].filter(Boolean).join(' ');
  if (context && labelCoversContext(context, variantLabel)) return context;

  const pieces = [];
  const variantLower = variantLabel.toLowerCase();
  const contextLower = context.toLowerCase();
  if (
    brandName &&
    !variantLower.includes(brandName.toLowerCase()) &&
    !contextLower.includes(brandName.toLowerCase())
  ) {
    pieces.push(brandName);
  }
  if (context && !variantLower.includes(context.toLowerCase()) && !labelCoversContext(variantLabel, context)) {
    pieces.push(context);
  }
  if (
    !context &&
    typeName &&
    !variantLower.includes(typeName.toLowerCase()) &&
    !labelCoversContext(variantLabel, typeName)
  ) {
    pieces.push(typeName);
  }
  pieces.push(variantLabel);

  return pieces.join(' ').replace(/\s+/g, ' ').trim();
}

export function buildContextualVariantLookup({ label, productContext, brand, productType } = {}) {
  const product = buildContextualProductInput({ label, productContext, brand, productType });
  const labelTokens = new Set(identityTokens(label));
  const brandTokens = distinctiveBrandTokens(brand);
  const labelHasBrandToken = brandTokens.some((word) => labelTokens.has(word));

  if (product && brandTokens.length > 0 && !labelHasBrandToken) {
    return { product, requireNamedBrand: true };
  }
  return product;
}
